import { CustomerKyc, HttpResponse } from "../types";
import HttpClientRequest from "../api/client-request";

export default class UserService {

    static async getCustomerKyc(userId: number, requestId?: string): Promise<HttpResponse> {
        let response;
        try {
            
            response = await HttpClientRequest.doGetRequest(`/users/customer/${userId}`, {}, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error fetching products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }

    static async updateCustomerKyc(payload: CustomerKyc, requestId?: string): Promise<HttpResponse> {
        let response;
        try {
            
            response = await HttpClientRequest.doPutRequest(`/users/customer/${payload.id}`, payload, {
                'Content-Type': 'application/json'
            }, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error fetching products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }

    static async deleteCustomerAccount(userId: Number, requestId?: string): Promise<HttpResponse> {
        let response;
        try {
            
            response = await HttpClientRequest.doDeleteRequest(`/users/customer/${userId}`, {}, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error fetching products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }
}